document.addEventListener("DOMContentLoaded", function () {
  const slidingCardSwipers = document.querySelectorAll(
    ".sliding-cards .card-swiper",
  );

  if (slidingCardSwipers.length > 0) {
    slidingCardSwipers.forEach((cardSwiper) => {
      const swiperId = cardSwiper.dataset.unique;

      const servicesSwiper = new Swiper(
        `.card-swiper[data-unique=${swiperId}]`,
        {
          // Optional parameters
          loop: true,
          slidesPerView: "auto",
          slidesPerViewAutoSlideSize: 500,
          spaceBetween: 100,
          autoplay: false,
          allowTouchMove: true, // Enable touch/swipe gestures
          speed: 800,
          navigation: {
            nextEl: `.sliding-cards .swiper-controls[data-controls=${swiperId}] .next`,
            prevEl: `.sliding-cards .swiper-controls[data-controls=${swiperId}] .prev`,
          },
        },
      );
    });
  }
});
